export enum MentionSearchFacetTypesEnum {
    language = 'LANGUAGE',
    mediaType = 'MEDIA_TYPE',
    sentiment = 'SENTIMENT',
    continent = 'CONTINENT',
    audience = 'AUDIENCE',
    country = 'COUNTRY',
    province = 'PROVINCE',
    county = 'COUNTY',
    city = 'CITY',
    outlet = 'OUTLET_NAME',
    outletByAudienceReach = 'OUTLET_BY_AUDIENCE_REACH',
    outletByAVE = 'OUTLET_BY_AVE',
    outletByDomainAuthority = 'OUTLET_BY_DOMAIN_AUTHORITY',
    contact = 'CONTACT_NAME',
    authorByAudienceReach = 'AUTHOR_BY_AUDIENCE_REACH',
    authorByAVE = 'AUTHOR_BY_AVE',
    publication = 'PUBLICATION',
    tag = 'TAG',
    tagGroup = 'TAG_GROUP',
    hashtags = 'HASHTAGS',
    prominence = 'PROMINENCE',
    words = 'WORDS', // TODO: To be added by backend
    handles = 'HANDLES', // TODO: To be added by backend,
    tweetType = 'TWEET_TYPE',
    contactUuid = 'CONTACT_UUID',
    outletUuid = 'OUTLET_UUID',
    linkedinType = 'LINKEDIN_TYPE',
    saveSourceType = 'SAVE_SOURCE_TYPE',
    savingSearch = 'SAVING_SEARCH',
    domainAuthority = 'DOMAIN_AUTHORITY',
    blueskyType = 'BLUESKY_TYPE',
    broadcastType = 'BROADCAST_TYPE',

    // LLM FACETS
    brandScore = 'VI_BRAND_SCORE',
    visibilityScore = 'VI_ORGANIC_INCLUSION',
    presenceRate = 'VI_BRAND_MENTIONED ',
    rankWhenListed = 'VI_MENTION_RANK',
    sentimentScore = 'VI_SENTIMENT',
    accuracyScore = 'VI_FACTUAL_ACCURACY',
    riskRate = 'VI_RISK_FLAG',
    citationPerScan = 'VI_CITATION_COUNT'
}
